import React from "react";
import PropTypes from "prop-types";
import "./BigLabel.scss";

const BigLabel = ({ children, onClick }) => (
  <span onClick={onClick} className="big-label">
    {children}
  </span>
);

BigLabel.propTypes = {
  onClick: PropTypes.func
};

export default BigLabel;
